import { Children } from 'react'

import styled from 'styled-components'

type Props = {
	/** The width of each column, eg `[1, 2]` in fr. Defaults to `1fr` per column */
	columns?: Array<number>
	/** The gap between each column. Defaults to `12` */
	gap?: number
}

/**
 * Allows quick layouts of columns, typically for increasing the density of
 * input fields in forms.
 * @example
 * ```tsx
 * <GridRow columns={[1, 2]}>
 * 	<Input {...} />
 * 	<Input {...} />
 * </GridRow>
 * ```
 */
export const GridRow = styled.div<Props>`
	display: grid;
	column-gap: ${({ gap = 12 }) => gap}px;
	grid-template-columns: ${({ columns, children }) =>
		columns ? columns.map((width) => `${width}fr`).join(' ') : `repeat(${Children.count(children)}, 1fr)`};
`
